import { type ReactNode } from 'react'

import type { ClinicSession } from '../../api/specialists'
import { sessionLabel } from '../../lib/sessionLabel'

/**
 * Radio group of a specialist's clinic sessions at one hospital (M14-T08). The
 * patient picks one; the date picker then offers only that session's weekday
 * (ADR-0030). A proper fieldset/radiogroup so it's keyboard-navigable.
 */
export function SessionPicker({
  sessions,
  selectedId,
  onSelect,
}: {
  sessions: ClinicSession[]
  selectedId: string | null
  onSelect: (session: ClinicSession) => void
}): ReactNode {
  return (
    <fieldset className="flex flex-col gap-2 border-0 p-0">
      <legend className="mb-1 text-[13px] font-medium text-ink-1">
        Choose a clinic
      </legend>
      {sessions.map((s) => {
        const checked = s.id === selectedId
        return (
          <label
            key={s.id}
            className={`flex cursor-pointer items-center gap-2.5 rounded-r3 border p-3 ${
              checked
                ? 'border-accent bg-accent-bg'
                : 'border-line-2 bg-bg-app hover:bg-bg-soft'
            }`}
          >
            <input
              type="radio"
              name="clinic-session"
              value={s.id}
              checked={checked}
              onChange={() => onSelect(s)}
              className="accent-accent"
            />
            <span className="text-[13px] text-ink-1">{sessionLabel(s)}</span>
          </label>
        )
      })}
    </fieldset>
  )
}
